module.exports = __webpack_public_path__ + "static/media/x_button.3c51eb0d.svg";